import { useState } from 'react';

interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/cb1950af-05a2-4ad4-b869-128c68de74e3.png"
              alt="あさぎり荘"
              className="h-12 w-auto cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('cuisine')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-forest-800 hover:text-gold-600' : 'text-white hover:text-gold-300'
              }`}
            >
              こだわりの高原料理
            </button>
            <button
              onClick={() => scrollToSection('camp')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-forest-800 hover:text-gold-600' : 'text-white hover:text-gold-300'
              }`}
            >
              合宿のご案内
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-forest-800 hover:text-gold-600' : 'text-white hover:text-gold-300'
              }`}
            >
              料金案内
            </button>
            <button
              onClick={() => scrollToSection('access')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-forest-800 hover:text-gold-600' : 'text-white hover:text-gold-300'
              }`}
            >
              アクセス・周辺案内
            </button>
          </div>

          {/* Contact & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:079-667-8119"
              className={`flex items-center space-x-2 text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-forest-800 hover:text-gold-600' : 'text-white hover:text-gold-300'
              }`}
            >
              <i className="ri-phone-line"></i>
              <span className="whitespace-nowrap">079-667-8119</span>
            </a>
            <button
              onClick={() => scrollToSection('cta')}
              className="px-6 py-2.5 bg-gold-600 text-white text-sm font-medium rounded-full hover:bg-gold-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              ご予約
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-forest-800' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 py-4">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('cuisine')}
                className="text-sm font-medium text-forest-800 hover:text-gold-600 transition-colors text-left px-4 cursor-pointer"
              >
                こだわりの高原料理
              </button>
              <button
                onClick={() => scrollToSection('camp')}
                className="text-sm font-medium text-forest-800 hover:text-gold-600 transition-colors text-left px-4 cursor-pointer"
              >
                合宿のご案内
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className="text-sm font-medium text-forest-800 hover:text-gold-600 transition-colors text-left px-4 cursor-pointer"
              >
                料金案内
              </button>
              <button
                onClick={() => scrollToSection('access')}
                className="text-sm font-medium text-forest-800 hover:text-gold-600 transition-colors text-left px-4 cursor-pointer"
              >
                アクセス・周辺案内
              </button>
              <a
                href="tel:079-667-8119"
                className="text-sm font-medium text-forest-800 hover:text-gold-600 transition-colors text-left px-4 cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                079-667-8119
              </a>
              <button
                onClick={() => scrollToSection('cta')}
                className="mx-4 px-6 py-2.5 bg-gold-600 text-white text-sm font-medium rounded-full hover:bg-gold-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                ご予約
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}